<template>
  <v-container grid-list-xl class="pa-5">
    <v-row wrap>
      <v-col cols="12">
        <v-alert v-if="is_premium" dense text class="body-2 mb-5 pb-5" type="info">
          Berikut ini merupakan daftar grup yang ada pada instansi Anda. Silakan
          <b>klik tombol tambah (+)</b> untuk menambah persetujuan baru.
        </v-alert>
        <m-card-list
          two-line
          title="Persetujuan Cuti"
          label-cari="Cari Persetujuan"
          :add="true"
          edit
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @search="
            (search) => {
              textSearch = search
              load()
            }
          "
          @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
          @add="add"
        >
          <template v-slot:items="{ props, item }">
            <tr>
              <td> Persetujuan Cuti </td>
              <td>{{ pVal(item, 'nama') }}</td>
              <td>
                <ul>
                  <li small class="mr-1" v-for="(gp, g) in item.groups" :key="g">
                    {{ gp.nama }}
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li small class="mr-1" v-for="(gp, g) in item.members" :key="g">
                    {{ gp.nama }}
                  </li>
                </ul>
              </td>
              <td>
                <m-menu left style="float: right" :items="more_menu" :object="item" />
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
    </v-row>
    <ChangeDlg ref="dlg" :kategoris="kategoris" :groups="groups" @reload="load" />
  </v-container>
</template>

<script>
import { isCan } from '@/tools'
import ChangeDlg from '../components/Form.vue'
import BlockCard from '@/components/BlockCard'

export default {
  components: {
    ChangeDlg,
    BlockCard,
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      kategoris: [],
      groups: [],
      headers: [
        { text: 'Kategori Penilaian', align: 'left', value: 'kategori' },
        { text: 'Nama Persetujuan', align: 'left', value: 'nama' },
        { text: 'Grup Persetujuan', align: 'left', value: 'ajuan' },
        { text: 'Grup Ajuan', align: 'left', value: 'persetujuan' },
        { text: '', sortable: false },
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] },
      },
      more_menu: [
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
          check: () => isCan('group.update'),
        },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: () => isCan('group.destroy'),
        },
      ],
    }
  },
  computed: {},
  activated() {
    this.load()
    this.loadKategori()
    this.loadGroup()
  },
  methods: {
    load() {
      this.$store
        .dispatch('persetujuan/get', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    loadKategori() {
      this.$store
        .dispatch('kategori/getAll', {
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.kategoris = data || []
        })
        .catch((e) => e)
    },
    loadGroup() {
      this.$store
        .dispatch('grup/get', {
          organisasi_id: this.organisasi_id,
        })
        .then((data) => {
          if (!this.allowLeave) this.$router.replace({ name: 'home' })
          this.groups = (data && data.data) || []
        })
        .catch((e) => e)
    },
    add() {
      this.$refs.dlg.open()
    },
    async edit(item) {
      const resp = await this.$store
        .dispatch('persetujuan/detail', {
          organisasi_id: this.organisasi_id,
          id: item.persetujuan_id,
        })
        .then(({ data }) => data)

      if (Number(item.is_digunakan) === 1) {
        this.$confirmDanger(
          [
            `<div class="text-h6"><b>Penting</b><br/></div>`,
            `Ditemukan proses persetujuan cuti yang telah ada. Jika melakukan perubahan, maka proses yang telah selesai, akan tetap ada riwayatnya. Bagi yang akan/dalam proses, maka sistem akan menyesuaikan dengan hasil perubahan.<br/> <br/>`,
            `Apakah yakin Anda akan melakukan perubahan kelola persetujuan?`,
          ].join(''),
          {
            color: 'warning',
          }
        ).then(() => {
          this.$refs.dlg.open(Object.assign({}, resp, { id: item.persetujuan_id }))
        })
      } else {
        this.$refs.dlg.open(Object.assign({}, resp, { id: item.persetujuan_id }))
      }
    },
    hapus(item) {
      let html = `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama}<br>
        </div>
      `

      if (Number(item.is_digunakan) === 1) {
        html = [
          `<div class="text-h6"><b>Penting</b><br/></div>`,
          `Ditemukan proses persetujuan cuti yang telah ada. Jika melakukan hapus, maka proses yang telah selesai, akan tetap ada riwayatnya. Bagi yang akan/dalam proses, maka sistem akan menyesuaikan dengan hasil perubahan. <br/> <br/>`,
          `Apakah yakin Anda akan melakukan perubahan kelola persetujuan?`,
        ].join('')
      }

      this.$confirmDanger(html, { color: 'red' })
        .then(() =>
          this.$store.dispatch('persetujuan/drop', {
            organisasi_id: this.organisasi_id,
            id: item.persetujuan_id,
          })
        )
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
  },
}
</script>
